import api from '../api';

// Mocks
// import mockPagesData from '../../mocks/mock-pages';

/**
 * Get manager pages
 * @returns {Promise<ApiPages>} The manager pages
 */
export const getManagerPages = async () => {
  const response = await api.get('/pages');
  return response.data;
  // return mockPagesData;
};
